fragment CategoryWithAncestorsFragment on CategoryWithAncestors {
    id
    slug
    path
    parent_id
    name
    description
    image_id
    image {
        ...MediaResourceFragment
    }
    ancestors {
        ...CategoryFragment
    }
    path_string
}